import { requireAnySystemPermission } from '@juvare/contact-management/backend/features/permissions/shared';
export const getDefaultMissionsTab = (userState) => {
    const allowMissionChange = requireAnySystemPermission(userState, 'manage-missions', 'manage-all-admin-missions');
    return allowMissionChange ? 'manageMissions' : 'myMissions';
};
